<template>
  <div class="form-submitted">
    <Icon
      name="lucide:mail-check"
      size="40"
    />
    <div class="submitted-title">
      Thank you for contacting us!
    </div>
    <p class="submitted-description">
      We have submitted your support request.
    </p>
    <p class="submitted-description">
      You will hear back from one of our team members shortly.
    </p>
    <MsgButton
      type="secondary"
      class="close-button"
      @click.prevent="$emit('close')"
    >
      Close window
    </MsgButton>
  </div>
</template>

<script setup>
import MsgButton from "../../MsgUi/MsgButton.vue";
defineEmits(["close"]);
</script>

<style scoped>
.form-submitted{align-items:center;align-self:stretch;color:var(--color-blue-500);display:flex;flex-direction:column;gap:24px;justify-content:flex-end;padding:var(--space-600);padding-top:var(--space-1000);--color-blue-300:#6184ca;--color-blue-500:#1850c1;--color-grey-950:#2d2d2d;--color-white:#fff;--space-200:8px;--space-400:16px;--space-600:24px;--space-1000:40px;--border-radius-full:9999px}.submitted-description,.submitted-title{color:var(--color-grey-950);font-family:Inter;text-align:center}.submitted-title{font-size:16px;font-weight:700;line-height:120%}.submitted-description{font-size:14px;font-weight:400;line-height:18px}.close-button{align-items:center;background:var(--color-white);border:1px solid var(--color-blue-300);border-radius:var(--border-radius-full);color:var(--color-blue-500);cursor:pointer;display:flex;flex:1 0 0;gap:var(--space-200);justify-content:center;padding:var(--space-200) var(--space-400);transition:all .2s;width:100%}
</style>
